import React, {useEffect, useRef, useState} from 'react';

export default function Select({options, value, onChange, placeholder, style, noMaxHeight}) {
    const ref = useRef();
    const [open, setOpen] = useState(false);

    const handleChange = (value) => {
        setOpen(false);
        if (onChange !== undefined) {
            onChange(value);
        }
    }

    const handleClickOutside = (event) => {
        if (ref && !ref.current.contains(event.target)) {
            setOpen(false);
        }
    }

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const selectedValue = options && value !== undefined ? options.find(option => option.value === value)?.label : undefined;

    return (
        <div
            className={`selectr-container selectr-desktop clearable ${selectedValue !== undefined ? 'has-selected' : ''} ${open ? 'open' : ''}`}
            style={{display: 'flex', alignItems: 'center', ...style}}
            ref={ref}
        >
            <button className="selectr-clear" type="button" onClick={() => handleChange('')}/>
            <div className={'selectr-selected'} aria-expanded={'true'} onClick={() => setOpen(!open)}>
                <div className={'selectr-label'}>
                    {selectedValue}
                </div>
                <div className={'selectr-placeholder'} style={{textOverflow: 'ellipsis', overflow: 'hidden'}}>
                    {placeholder}
                </div>
            </div>
            <div className="selectr-options-container">
                <ul className="selectr-options" role="tree" aria-hidden="false" aria-expanded="true" style={noMaxHeight ? {maxHeight: 'none'} : {}}>
                    {open && options && options.map(({value, label}) => (
                        <SelectOption key={value} onClick={() => handleChange(value)}>
                            {label}
                        </SelectOption>
                    ))}
                </ul>
            </div>
        </div>
    )
}

function SelectOption({children, onClick}) {
    const [hover, setHover] = useState(false);
    return (
        <li
            className={`selectr-option ${hover ? 'active' : ''}`}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={onClick}
        >
            {children}
        </li>
    )
}